/** The events page (`/events`): every upcoming event by date (web-client-app D11, task 8.4); on a phone, the app's Book screen. */
import { PhoneBookScreen } from '../phone/PhoneBookScreen';
import { EventsGrid } from '../pieces/events-grid';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';

export function EventsPage() {
  usePageTitle('Events');
  const phone = useAppScreens();
  // Below 768px the page is the Mini App's Book screen on its Events tab (Gabriel 2026-10-21).
  if (phone) return <PhoneBookScreen tab="events" />;
  return <EventsGrid />;
}
